import { Navigation } from "swiper/modules";
import CustomIcon from "@/components/ui/custom-icon";
import { useCollectionsData } from "@/views/collections/hooks/useCollectionsData";
import CollectionSectionCard from "./collection-card";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import clsx from "clsx";

const COLLECTION_SWIPER_PREV_CLASS = "collection-swiper-button-prev";
const COLLECTION_SWIPER_NEXT_CLASS = "collection-swiper-button-next";

const CollectionSection = () => {
  const { collections, isLoading } = useCollectionsData();

  if (!collections || !collections.length || isLoading) return null;

  return (
    <Container className={S.wrapper}>
      <div className={S.collectionList}>
        <Swiper
          modules={[Navigation]}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
          }}
          navigation={{
            nextEl: `.${COLLECTION_SWIPER_NEXT_CLASS}`,
            prevEl: `.${COLLECTION_SWIPER_PREV_CLASS}`,
          }}
        >
          {collections.map(collection => (
            <SwiperSlide key={collection.id}>
              <CollectionSectionCard collection={collection} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={clsx(COLLECTION_SWIPER_PREV_CLASS, S.customNavArrow, S["customNavArrow--back"])}>
        <CustomIcon fileName={"chevron-right"} />
      </div>
      <div className={clsx(COLLECTION_SWIPER_NEXT_CLASS, S.customNavArrow)}>
        <CustomIcon fileName={"chevron-right"} />
      </div>
    </Container>
  );
};

export default CollectionSection;
